import React from 'react'
import { Routes, Route } from 'react-router-dom'
import SingleBlog from "../pages/SingleBlog";
import PodCast from "../pages/Podcast/PodCast";
import Footer from './Footer';
import SurvivalSkills from '../pages/SurvivalSkills';
import Health from '../pages/Health';
import Nutrition from '../pages/Nutrition';
import Quotes from '../pages/Quotes';
import HomePage from '../pages/Music/HomePage';
import SingleArtist from '../pages/Music/SingleArtist';
import General from '../pages/General';
import Religion from '../pages/Religion';
import Blogs from '../pages/Blogs';
import About from '../pages/About';

const Layout = () => {
  return (
      <>


    {/*  TODO: Integrate Spotify */}
    < Routes>
    <Route path="podcast" element={<PodCast />} />
    <Route path="single-artist" element={<SingleArtist />} />
    <Route path="musics" element={<HomePage />} />
    <Route path="about" element={<About />} />
    <Route path="blogs" element={<Blogs />} />
    <Route path="blogs/general-life" element={<General />}/>
    <Route path="blogs/general-life/:slug" element={<SingleBlog />} />
    <Route path="blogs/religion" element={<Religion />} />
    <Route path="blogs/religion/:slug" element={<SingleBlog />} />
    <Route path="blogs/:slug" element={<SingleBlog />} />
    <Route path="blogs/health" element={<Health />} />
    <Route path="blogs/health/:slug" element={<SingleBlog />} />
    <Route path="blogs/nutrition" element={<Nutrition />} />
    <Route path="blogs/nutrition/:slug" element={<SingleBlog />} />
    <Route path="blogs/quotes" element={<Quotes />} />
    <Route path="blogs/survival-skills" element={<SurvivalSkills />} />
    <Route path="blogs/survival-skills/:slug" element={<SingleBlog />} />
    </Routes>
      <Footer />
      </>
  )
}

export default Layout